import {
  SetDetailsErrorAction,
  SetTransactionDetailAction,
} from '@portal/actions/details';
import {
  SET_DETAILS,
  SET_DETAILS_ERROR,
  TRANSACTION_GENERATE_QR_CODE,
  UNSET_DETAILS,
} from '../actions/actionTypes';

export const initialState: reducers.DetailsState = {
  type: null,
  error: null,
  transaction: null,
  qrCodeContent: null,
};

const detailsReducer = (
  state = initialState,
  action: SetDetailsErrorAction | SetTransactionDetailAction
) => {
  const { payload, type } = action;
  switch (type) {
    case SET_DETAILS:
      return {
        ...state,
        ...payload,
      };
    case TRANSACTION_GENERATE_QR_CODE:
      if (typeof payload !== 'string') {
        return state;
      }

      return {
        ...state,
        qrCodeContent: payload,
      };
    case SET_DETAILS_ERROR:
      if (payload instanceof Error) {
        return {
          ...state,
          error: payload,
        };
      }

      return state;
    case UNSET_DETAILS:
      return initialState;
    default:
      return state;
  }
};

export default detailsReducer;
